/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-explicit-any */
// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {
	Collapse,
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
} from '@mui/material';
// material-ui
import { useTheme } from '@mui/material/styles';
import { IconChevronDown, IconChevronUp } from '@tabler/icons';
import { useEffect, useState } from 'react';
// third-party
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// project imports
import NavItem from '../NavItem';

const NavCollapse = ({ menu, level }: any) => {
	const location = useLocation();
	const theme: any = useTheme();
	const customization = useSelector((state: any) => state.customization);
	const { t } = useTranslation();

	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState(null);

	const handleClick = () => {
		setOpen(!open);
		setSelected(!selected ? menu.id : null);
	};

	useEffect(() => {
		const urlParentPath = location.pathname.toString().split('/')[1];

		if (
			urlParentPath &&
			menu.children &&
			menu.children.find((child: any) => child.url.includes(urlParentPath))
		) {
			handleClick();
		}
		// eslint-disable-next-line
	}, []);

	// menu collapse & item
	const menus = menu.children?.map((item: any) => {
		switch (item.type) {
			case 'collapse':
				return <NavCollapse key={item.id} menu={item} level={level + 1} />;
			case 'item':
				return <NavItem key={item.id} item={item} level={level + 1} />;
			default:
				return (
					<Typography key={item.id} variant='h6' color='error' align='center'>
						Menu Items Error
					</Typography>
				);
		}
	});

	const Icon = menu.icon;
	const menuIcon = menu.icon ? (
		<Icon
			strokeWidth={1.5}
			size='1.3rem'
			style={{ marginTop: 'auto', marginBottom: 'auto' }}
		/>
	) : (
		<FiberManualRecordIcon
			sx={{
				width: selected === menu.id ? 8 : 6,
				height: selected === menu.id ? 8 : 6,
			}}
			fontSize={level > 0 ? 'inherit' : 'medium'}
		/>
	);

	return (
		<>
			<ListItemButton
				sx={{
					borderRadius: `${customization.borderRadius}px`,
					mb: 0.5,
					alignItems: 'flex-start',
					py: level > 1 ? 1 : 1.25,
					pl: `${level * 12}px`,
				}}
				// selected={selected === menu.id}
				onClick={handleClick}
			>
				<ListItemIcon sx={{ my: 'auto', minWidth: !menu.icon ? 18 : 36 }}>
					{menuIcon}
				</ListItemIcon>
				<ListItemText
					primary={
						<Typography
							variant={selected === menu.id ? 'h5' : 'body1'}
							color='inherit'
							sx={{ my: 'auto' }}
						>
							{t(menu.title)}
						</Typography>
					}
					secondary={
						menu.caption && (
							<Typography
								variant='caption'
								sx={{ ...theme.typography.subMenuCaption }}
								display='block'
								gutterBottom
							>
								{menu.caption}
							</Typography>
						)
					}
				/>
				{open ? (
					<IconChevronUp
						stroke={1.5}
						size='1rem'
						style={{ marginTop: 'auto', marginBottom: 'auto' }}
					/>
				) : (
					<IconChevronDown
						stroke={1.5}
						size='1rem'
						style={{ marginTop: 'auto', marginBottom: 'auto' }}
					/>
				)}
			</ListItemButton>
			<Collapse in={open} timeout='auto' unmountOnExit>
				<List
					component='div'
					disablePadding
					sx={{
						position: 'relative',
						'&:after': {
							// eslint-disable-next-line quotes
							content: "''",
							position: 'absolute',
							left: 12,
							top: 8,
							height: '85%',
							width: 2,
							opacity: 1,
							background: 'whitesmoke',
						},
					}}
				>
					{menus}
				</List>
			</Collapse>
		</>
	);
};

export default NavCollapse;
